<template>
  <div v-loading.fullscreen.lock="loading" class="notice-list">
    <!-- 头部 -->
    <top-part :rightPart="true">
      <template slot="title">通知公告</template>
    </top-part>

    <!-- 通知列表 -->
    <div class="notice-content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            v-for="item in dataList"
            :key="item.id"
            class="notice-item"
            @click="goToDetail(item)"
          >
            <!-- 未读标识 -->
            <div v-if="item.isRead === '0'" class="unread-dot"></div>

            <!-- 通知内容 -->
            <div class="notice-main">
              <!-- 标题 -->
              <div class="notice-title" :class="{ 'unread': item.isRead === '0' }">
                {{ item.title }}
              </div>

              <!-- 摘要 -->
              <div class="notice-summary">
                {{ item.summary }}
              </div>

              <!-- 底部信息 -->
              <div class="notice-footer">
                <div class="notice-info">
                  <span class="notice-author">{{ item.createName }}</span>
                  <span class="notice-time">{{ item.publishTime }}</span>
                </div>
                <div class="notice-category">
                  <span class="category-tag">{{ item.categoryName }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>

      <!-- 空状态 -->
      <van-empty v-if="!loading && dataList.length === 0" description="暂无通知" />
    </div>
  </div>
</template>

<script>
import topPart from "../../components/topPart";
import { announcementVisiblePageList, announcementMarkAsRead } from "@/common/api";
import moment from "moment";

export default {
  components: {
    topPart,
  },
  data() {
    return {
      loading: false,
      refreshing: false,
      finished: false,
      dataList: [],
      currentPage: 1,
      pageSize: 5
    };
  },
  mounted() {
  },
  methods: {
    // 获取通知列表
    getAnnouncementVisiblePageList(isRefresh = false) {
      if (isRefresh) {
        this.currentPage = 1;
        this.finished = false;
        this.dataList = [];
      }

      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize
      };

      announcementVisiblePageList(params).then(res => {
        if (res.code == 200) {
          const { list,count } = res.data;

          if (isRefresh) {
            this.dataList = list || [];
          } else {
            this.dataList = [...this.dataList, ...(list || [])];
          }

          // 判断是否还有更多数据
          if (!list || list.length < this.pageSize || this.dataList.length >= count) {
            this.finished = true;
          }

          this.loading = false;
          this.refreshing = false;
        } else {
          this.loading = false;
          this.refreshing = false;
          this.$toast(res.message || '获取数据失败');
        }
      }).catch(() => {
        this.loading = false;
        this.refreshing = false;
        this.$toast('网络错误，请重试');
      });
    },

    // 下拉刷新
    onRefresh() {
      this.getAnnouncementVisiblePageList(true);
    },

    // 上拉加载更多
    onLoad() {
      if (!this.finished) {
        // 如果是第一次加载，不需要增加页码
        if (this.dataList.length > 0) {
          this.currentPage++;
        }
        this.getAnnouncementVisiblePageList();
      } else {
        this.loading = false;
      }
    },
    // 跳转到详情页
    goToDetail(item) {
      // 如果是未读状态，标记为已读
      if (item.isRead === '0') {
        this.markAsRead(item.id);
        item.isRead = '1'; // 立即更新本地状态
      }

      // 跳转到详情页
      this.$router.push({
        path: '/noticeDetail',
        query: {
          id: item.id
        }
      });
    },

    // 标记为已读
    markAsRead(id) {
      announcementMarkAsRead({ id }).then(res => {
        if (res.code == 200) {
          // 标记成功
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.notice-list {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.notice-content {
  margin-top: 45px
  padding: 0 16px;
  padding-top: 10px;
}

.notice-item {
  position: relative;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;

  &:active {
    background-color: #f8f8f8;
    transform: scale(0.98);
  }
}

.unread-dot {
  position: absolute;
  top: 12px;
  left: 8px;
  width: 6px;
  height: 6px;
  background-color: #ff4444;
  border-radius: 50%;
}

.notice-main {
  margin-left: 0;
}

.notice-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  &.unread {
    color: #1a1a1a;
    font-weight: 600;
  }
}

.notice-summary {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
  margin-bottom: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.notice-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.notice-info {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #999;
}

.notice-author {
  margin-right: 12px;
}

.notice-time {
  color: #ccc;
}

.notice-category {
  .category-tag {
    background: #e8f4fd;
    color: #1890ff;
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 12px;
    border: 1px solid #d9ecff;
  }
}

// 覆盖 vant 组件样式
:deep(.van-pull-refresh) {
  background-color: transparent;
}

:deep(.van-list) {
  background-color: transparent;
}

:deep(.van-loading) {
  background-color: transparent;
}

:deep(.van-empty) {
  padding: 60px 0;
}
</style>